import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';

export const getGlobalLabels = (fieldKey: string): Promise<string[]> =>
	fetchJson<string[]>(`/rest/polaris/global-fields/labels/${fieldKey}`);
